export default __webpack_public_path__ + "imgs/5d0173188b0a50c784074a5a14ddb6e3.png";